import React from 'react'
import styles from './DropdownSelect.module.scss'
import Select, { components } from 'react-select'
import makeAnimated from 'react-select/animated'
import { IconClose, colors } from 'assets'
import { selectStyles, applyTheme } from './select-styles'
import { DropdownSelectProps } from './types'
import cl from 'classnames'

const MultiValueRemove = props => {
  return (
    components.MultiValueRemove && (
      <components.MultiValueRemove {...props}>
        <IconClose fill={colors.borderGrey} />
      </components.MultiValueRemove>
    )
  )
}

const MultiValue = props => {
  return (
    components.MultiValue && (
      <components.MultiValue {...props}>
        <span title={props.data.label}>{props.children}</span>
      </components.MultiValue>
    )
  )
}

const DropdownSelectComponent = (props: DropdownSelectProps) => {
  const {
    className,
    closeMenuOnSelect = false,
    components: providedComponents,
    labelIcon: Icon,
    isMulti = true,
    styles: providedStyles = {},
    isClearable = false,
    ...rest
  } = props

  const Control = controlProps => {
    return (
      <components.Control {...controlProps}>
        {Icon && <Icon fill={colors.borderGrey} />}
        {controlProps.children}
      </components.Control>
    )
  }

  return (
    <Select
      className={cl(styles.container, className)}
      closeMenuOnSelect={closeMenuOnSelect}
      components={makeAnimated({
        MultiValueRemove, Control, MultiValue, ...providedComponents
      })}
      isMulti={isMulti}
      styles={{ ...selectStyles, ...providedStyles }}
      isClearable={isClearable}
      theme={applyTheme}
      {...rest}
    />
  )
}

const DropdownSelect = DropdownSelectComponent
export { DropdownSelect }
